import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { ScoutLoopMark } from "../components/brand/ScoutLoopMark";
import { Copyright } from "../components/shared/Copyright";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex bg-white font-['Inter'] selection:bg-amber-100">
      <div className="hidden lg:flex w-1/2 bg-slate-950 text-white p-16 flex-col justify-between relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-amber-600/20 rounded-full blur-[120px] -mr-96 -mt-96 animate-pulse"></div>
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <ScoutLoopMark size={40} color="#d97706" />
            <span className="text-3xl font-black tracking-tighter uppercase italic text-white ml-1">
              ScoutLoop
            </span>
          </div>
        </div>
        <div className="relative z-10 max-w-xl">
          <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full border border-white/5 mb-8">
            <Sparkles size={16} className="text-amber-400" />
            <span className="text-[10px] font-black uppercase tracking-widest">
              Verified Recruitment Engine
            </span>
          </div>
          <h1 className="text-8xl font-black mb-8 leading-[0.85] uppercase italic tracking-tighter">
            OWN THE <br />
            <span className="text-amber-600 underline decoration-amber-600/20">
              GRIDIRON.
            </span>
          </h1>
          <p className="text-slate-400 text-xl mb-12 leading-relaxed font-medium">
            The all-in-one digital locker for the next generation of D1
            athletes. Join the elite network.
          </p>
        </div>
        <div className="relative z-10 flex justify-between items-center text-[10px] font-black uppercase tracking-widest text-slate-600">
          <Copyright />
          <span className="flex items-center gap-2">
            <Lock size={12} /> SECURE SIGNUP
          </span>
        </div>
      </div>
      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center p-8 bg-slate-50">
        {children}
      </div>
    </div>
  );
};
